<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      border
      ref="tableRef"
      v-loading="loading"
      highlight-current-row
      :height="maxHeight"
      @sort-change="sortChange"
    >
      <template v-for="(propItem, index) in propList" >
        <el-table-column :key="index" v-bind="propItem" show-overflow-tooltip>
          <template #default="scope">
            <slot :name="propItem.slotName" :row="scope.row">
              <span v-if="propItem.slotName == 'time'">
                {{scope.row[propItem.prop] | dateFormat}}
              </span>
              <span v-else>
                {{scope.row[propItem.prop]}}
              </span>
            </slot>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [tableMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    propList: {
      type: Array,
      default() {
        return []
      }
    },
    isHeight: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    maxHeight() {
      return this.isHeight ? window.innerHeight - 430 :  window.innerHeight - 200
    }
  },
  data() {
    return {
      // maxHeight: isHeight ? window.innerHeight - 520 :  window.innerHeight,
      // maxHeight: 0,
    };
  },
  mounted() {
    // this.maxHeight = this.isHeight ? window.innerHeight - 520 :  window.innerHeight - 200
  },
  methods: {
    sortChange(e) {
      this.$emit('sortChange', e)
    }
  }
};
</script>

<style></style>
